export enum ObjectType {
	DASHBOARD = 'dashboard',
	FILTER = 'filter',
	METRIC = 'metric',
	MODEL = 'model',
	ATTRIBUTE = 'attribute',
	ALERT = 'alert',
	SCORECARD = 'scorecard'
}
